// extracted by mini-css-extract-plugin
module.exports = {"root":"PageRow_root__bGbKH","rowTitle":"PageRow_rowTitle__6ae0r"};